<template>
  <div class="tourism-button-new" @click="newTourism">
    新しい観光ポイントの作成
  </div>
</template>

<script>
export default {
  methods: {
    newTourism: function () {
      this.$router.push('/tourism/new')
    }
  }
}
</script>

<style lang="scss" scoped>
.tourism-button-new {
  @include button-ol-primary;
}
</style>
